import * as i0 from '@angular/core';
import { TemplateRef, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ViewChild, EventEmitter, HostBinding, Output, ContentChildren, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/material/radio';
import { MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { startWith, delay, map } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
function RadioButtonComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c0 = ["*"];
function RadioGroupComponent_mat_radio_button_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RadioGroupComponent_mat_radio_button_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 4);
    i0.ɵɵtemplate(1, RadioGroupComponent_mat_radio_button_4_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disableRipple", true)("name", item_r1.name)("value", item_r1.value)("checked", item_r1.value == ctx_r0.value)("disabled", item_r1.disabled)("id", item_r1.id)("aria-label", item_r1.ariaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", item_r1.itemContent);
  }
}
let radioButtonCount = 1;
class RadioButtonComponent {
  constructor() {
    this.name = '';
    this.disabled = false;
    this.required = false;
    this.value = '';
    this.id = `radio-button-${radioButtonCount}`;
    this.checked = false;
    this.ariaLabel = '';
    this.itemContent = null;
    radioButtonCount++;
  }
  static {
    this.ɵfac = function RadioButtonComponent_Factory(t) {
      return new (t || RadioButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RadioButtonComponent,
      selectors: [["sol-radio-button"]],
      viewQuery: function RadioButtonComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemContent = _t.first);
        }
      },
      inputs: {
        name: "name",
        disabled: "disabled",
        required: "required",
        value: "value",
        id: "id",
        checked: "checked",
        ariaLabel: "ariaLabel"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function RadioButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, RadioButtonComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioButtonComponent, [{
    type: Component,
    args: [{
      selector: 'sol-radio-button',
      template: '<ng-template><ng-content></ng-content></ng-template>',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush
    }]
  }], () => [], {
    name: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    checked: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    itemContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();
class RadioGroupComponent {
  constructor(cdr) {
    this.cdr = cdr;
    this._role = 'group';
    this.name = '';
    this.disabled = false;
    this.required = false;
    this.value = '';
    this.inline = false;
    this.groupLabel = '';
    this.change = new EventEmitter();
    this.onChangeHandler = _ => {};
    this.onTouchedHandler = () => {};
  }
  get roleAttr() {
    return this._role;
  }
  // controlValueAccessorStart
  writeValue(obj) {
    this.value = obj;
    this.cdr.markForCheck();
  }
  registerOnChange(fn) {
    this.onChangeHandler = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedHandler = fn;
  }
  onChange(value) {
    this.value = value;
    this.onChangeHandler(this.value);
    this.change.emit(value);
  }
  ngAfterContentInit() {
    this.radioItems$ = this.radioButtons?.changes.pipe(startWith('')).pipe(delay(0)).pipe(map(() => {
      return this.radioButtons?.toArray();
    }));
  }
  static {
    this.ɵfac = function RadioGroupComponent_Factory(t) {
      return new (t || RadioGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RadioGroupComponent,
      selectors: [["sol-radio-group"]],
      contentQueries: function RadioGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, RadioButtonComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.radioButtons = _t);
        }
      },
      viewQuery: function RadioGroupComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatRadioGroup, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.radioGroup = _t.first);
        }
      },
      hostVars: 1,
      hostBindings: function RadioGroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.roleAttr);
        }
      },
      inputs: {
        name: "name",
        disabled: "disabled",
        required: "required",
        value: "value",
        inline: "inline",
        groupLabel: "groupLabel"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: RadioGroupComponent,
        multi: true
      }])],
      decls: 6,
      vars: 11,
      consts: [[1, "sol-radio-container"], [1, "radio-group-label"], ["aria-labelledby", "radio-group-label", 3, "name", "value", "disabled", "change"], [3, "disableRipple", "name", "value", "checked", "disabled", "id", "aria-label", 4, "ngFor", "ngForOf"], [3, "disableRipple", "name", "value", "checked", "disabled", "id", "aria-label"], [4, "ngTemplateOutlet"]],
      template: function RadioGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "mat-radio-group", 2);
          i0.ɵɵlistener("change", function RadioGroupComponent_Template_mat_radio_group_change_3_listener($event) {
            return ctx.onChange($event.value);
          });
          i0.ɵɵtemplate(4, RadioGroupComponent_mat_radio_button_4_Template, 2, 8, "mat-radio-button", 3);
          i0.ɵɵpipe(5, "async");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.groupLabel);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("horizontal", ctx.inline)("vertical", !ctx.inline);
          i0.ɵɵproperty("name", ctx.name)("value", ctx.value)("disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(5, 9, ctx.radioItems$));
        }
      },
      dependencies: [i1.MatRadioGroup, i1.MatRadioButton, i2.NgForOf, i2.NgTemplateOutlet, i2.AsyncPipe],
      styles: [".sol-radio-container .mat-mdc-radio-group{margin:0;gap:1rem;display:flex}.sol-radio-container .mat-mdc-radio-group.horizontal{flex-direction:row}.sol-radio-container .mat-mdc-radio-group.vertical{flex-direction:column}.sol-radio-container .radio-group-label{display:block;margin-bottom:1rem;color:var(--color-interface-text700);font-family:var(--typography-opensans-body-body1-font-family);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-size:var(--typography-opensans-body-body1-font-size);line-height:var(--typography-opensans-body-body1-line-height);text-decoration:var(--typography-opensans-body-body1-text-decoration);letter-spacing:var(--typography-opensans-body-body1-letter-spacing)}.sol-radio-container .mat-mdc-radio-button{font-family:var(--typography-opensans-body-body1-font-family)}.sol-radio-container .mat-mdc-radio-button.cdk-keyboard-focused .mdc-radio__outer-circle{outline:var(--color-globalstate-focus) solid var(--border-size1);outline-offset:calc(var(--outline-offset4) - var(--border-size1))}.sol-radio-container .mat-mdc-radio-button .mdc-form-field .mdc-label{display:block;color:var(--color-interface-text700);font-family:var(--typography-opensans-body-body1-font-family);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-size:var(--typography-opensans-body-body1-font-size);line-height:var(--typography-opensans-body-body1-line-height);text-decoration:var(--typography-opensans-body-body1-text-decoration);letter-spacing:var(--typography-opensans-body-body1-letter-spacing);padding-left:.5rem}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio{padding:0;height:1rem;width:1rem;border-radius:50%;box-sizing:border-box}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio.mdc-radio--disabled+label.mdc-label{color:var(--color-globalstate-disabled-content)}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mat-mdc-radio-touch-target,.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mat-ripple{display:none}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background{height:1rem;width:1rem;border-radius:50%}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background:before{display:none}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background .mdc-radio__outer-circle{border-width:1px;border-style:solid;transition:none}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background .mdc-radio__inner-circle{border:none;height:1rem;width:1rem;background:#fff}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control{height:1rem;width:1rem;border-radius:50%}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__inner-circle{transform:scale(.375);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-globalstate-disabled-background);border-color:var(--color-globalstate-disabled-borderalt);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:enabled+.mdc-radio__background .mdc-radio__outer-circle{background:#fff;border-color:var(--color-globalstate-active-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:enabled:hover+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-background125);border-color:var(--color-globalstate-active-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:enabled:active+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-globalstate-inactive-border);border-color:var(--color-globalstate-active-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:disabled+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-globalstate-disabled-border);border-color:var(--color-globalstate-disabled-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:enabled+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue450);border-color:var(--color-interface-blue450);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:enabled:hover+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue550);border-color:var(--color-interface-blue550);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:enabled:active+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue650);border-color:var(--color-interface-blue650);opacity:1}.sol-radio-container .mat-mdc-radio-button.cdk-keyboard-focused .mdc-form-field .mdc-radio input.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue550);border-color:var(--color-interface-blue550);opacity:1}.sol-radio-container .mat-mdc-radio-button.cdk-keyboard-focused .mdc-form-field .mdc-radio input.mdc-radio__native-control:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-background125);border-color:var(--color-globalstate-active-border);opacity:1}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioGroupComponent, [{
    type: Component,
    args: [{
      selector: 'sol-radio-group',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: RadioGroupComponent,
        multi: true
      }],
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"sol-radio-container\">\n  <label class=\"radio-group-label\">{{ groupLabel }}</label>\n  <mat-radio-group\n    [class.horizontal]=\"inline\"\n    [class.vertical]=\"!inline\"\n    [name]=\"name\"\n    [value]=\"value\"\n    [disabled]=\"disabled\"\n    aria-labelledby=\"radio-group-label\"\n    (change)=\"onChange($event.value)\"\n  >\n    <mat-radio-button\n      [disableRipple]=\"true\"\n      *ngFor=\"let item of radioItems$ | async\"\n      [name]=\"item.name\"\n      [value]=\"item.value\"\n      [checked]=\"item.value == value\"\n      [disabled]=\"item.disabled\"\n      [id]=\"item.id\"\n      [aria-label]=\"item.ariaLabel\"\n    >\n      <ng-container *ngTemplateOutlet=\"item.itemContent\"> </ng-container>\n    </mat-radio-button>\n  </mat-radio-group>\n</div>\n",
      styles: [".sol-radio-container .mat-mdc-radio-group{margin:0;gap:1rem;display:flex}.sol-radio-container .mat-mdc-radio-group.horizontal{flex-direction:row}.sol-radio-container .mat-mdc-radio-group.vertical{flex-direction:column}.sol-radio-container .radio-group-label{display:block;margin-bottom:1rem;color:var(--color-interface-text700);font-family:var(--typography-opensans-body-body1-font-family);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-size:var(--typography-opensans-body-body1-font-size);line-height:var(--typography-opensans-body-body1-line-height);text-decoration:var(--typography-opensans-body-body1-text-decoration);letter-spacing:var(--typography-opensans-body-body1-letter-spacing)}.sol-radio-container .mat-mdc-radio-button{font-family:var(--typography-opensans-body-body1-font-family)}.sol-radio-container .mat-mdc-radio-button.cdk-keyboard-focused .mdc-radio__outer-circle{outline:var(--color-globalstate-focus) solid var(--border-size1);outline-offset:calc(var(--outline-offset4) - var(--border-size1))}.sol-radio-container .mat-mdc-radio-button .mdc-form-field .mdc-label{display:block;color:var(--color-interface-text700);font-family:var(--typography-opensans-body-body1-font-family);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-size:var(--typography-opensans-body-body1-font-size);line-height:var(--typography-opensans-body-body1-line-height);text-decoration:var(--typography-opensans-body-body1-text-decoration);letter-spacing:var(--typography-opensans-body-body1-letter-spacing);padding-left:.5rem}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio{padding:0;height:1rem;width:1rem;border-radius:50%;box-sizing:border-box}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio.mdc-radio--disabled+label.mdc-label{color:var(--color-globalstate-disabled-content)}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mat-mdc-radio-touch-target,.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mat-ripple{display:none}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background{height:1rem;width:1rem;border-radius:50%}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background:before{display:none}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background .mdc-radio__outer-circle{border-width:1px;border-style:solid;transition:none}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__background .mdc-radio__inner-circle{border:none;height:1rem;width:1rem;background:#fff}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control{height:1rem;width:1rem;border-radius:50%}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__inner-circle{transform:scale(.375);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-globalstate-disabled-background);border-color:var(--color-globalstate-disabled-borderalt);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:enabled+.mdc-radio__background .mdc-radio__outer-circle{background:#fff;border-color:var(--color-globalstate-active-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:enabled:hover+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-background125);border-color:var(--color-globalstate-active-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:enabled:active+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-globalstate-inactive-border);border-color:var(--color-globalstate-active-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:disabled+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-globalstate-disabled-border);border-color:var(--color-globalstate-disabled-border);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:enabled+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue450);border-color:var(--color-interface-blue450);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:enabled:hover+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue550);border-color:var(--color-interface-blue550);opacity:1}.sol-radio-container .mat-mdc-radio-button .mdc-form-field div.mdc-radio .mdc-radio__native-control:checked:enabled:active+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue650);border-color:var(--color-interface-blue650);opacity:1}.sol-radio-container .mat-mdc-radio-button.cdk-keyboard-focused .mdc-form-field .mdc-radio input.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-blue550);border-color:var(--color-interface-blue550);opacity:1}.sol-radio-container .mat-mdc-radio-button.cdk-keyboard-focused .mdc-form-field .mdc-radio input.mdc-radio__native-control:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle{background:var(--color-interface-background125);border-color:var(--color-globalstate-active-border);opacity:1}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    roleAttr: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    name: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    inline: [{
      type: Input
    }],
    groupLabel: [{
      type: Input
    }],
    change: [{
      type: Output
    }],
    radioGroup: [{
      type: ViewChild,
      args: [MatRadioGroup]
    }],
    radioButtons: [{
      type: ContentChildren,
      args: [RadioButtonComponent]
    }]
  });
})();
class RadioModule {
  static {
    this.ɵfac = function RadioModule_Factory(t) {
      return new (t || RadioModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RadioModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MatRadioModule, CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioModule, [{
    type: NgModule,
    args: [{
      declarations: [RadioButtonComponent, RadioGroupComponent],
      imports: [MatRadioModule, CommonModule],
      exports: [RadioButtonComponent, RadioGroupComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of checkbox
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RadioButtonComponent, RadioGroupComponent, RadioModule };
